import * as React from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { Input, type InputProps } from '@/components/ui/Input'
import { cn } from '@/lib/utils'

export interface PasswordInputProps extends Omit<InputProps, 'type'> {
  /** Whether there's anything typed to reveal. The toggle is disabled (and
   *  the field stays masked) when there isn't — a placeholder of stars has
   *  nothing behind it to show. */
  hasValue: boolean
}

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ hasValue, className, ...props }, ref) => {
    const [visible, setVisible] = React.useState(false)
    const revealed = visible && hasValue

    return (
      <div className="relative">
        <Input type={revealed ? 'text' : 'password'} className={cn('pr-9', className)} ref={ref} {...props} />
        <button
          type="button"
          tabIndex={-1}
          disabled={!hasValue}
          onClick={() => setVisible((v) => !v)}
          className="absolute inset-y-0 right-0 flex items-center px-2.5 text-gray-400 hover:text-gray-600 disabled:cursor-not-allowed disabled:opacity-40"
          aria-label={revealed ? 'Hide value' : 'Show value'}
        >
          {revealed ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
    )
  },
)
PasswordInput.displayName = 'PasswordInput'
